<template>
	<div class="refuse">
		<el-dialog :title="title" width="30%" :visible.sync="dialogRefuseVisible" @close="resetForms('refuseFrom')">
			<div class="tipsBox">
				<tips-box></tips-box>
			</div>
			<div class="product_box mt-10">
				<product-box :row="row"></product-box>
			</div>
			<div class="user_info_box mt-10">
				<user-info-box :row="row"></user-info-box>
			</div>
			<div class="mt-20">
				<el-form :model="refuseFrom" ref="refuseFrom" :rules="refuseRuels">
					<el-form-item prop="receive">
						<el-input
							v-model="refuseFrom['receive']"
							type="textarea"
							autocomplete="off"
							placeholder="请填写拒绝带货理由"
							maxlength="80"
							show-word-limit
						></el-input>
					</el-form-item>
				</el-form>
				<p class="yx-color-text-primary fz-14">拒绝带货后，请联系团长确认退样相关事宜</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogRefuseVisible = false">取 消</el-button>
				<el-button type="primary" @click="refuseConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import tipsBox from '@/components/common/tipsBox';
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import { OrderRefuse } from '@/api/cooperationProgress';
export default {
	components: {
		productBox,
		userInfoBox,
		tipsBox,
	},
	name: 'refuse',
	data() {
		return {
			dialogRefuseVisible: false,
			refuseFrom: {
				receive: '',
			},
			refuseRuels: {
				receive: [{ required: true, message: '请填写拒绝带货理由', trigger: 'blur' }],
			},
			title: '拒绝带货',
			row: {},
		};
	},
	methods: {
		initrefuseFun(row) {
			this.row = row;
			this.dialogRefuseVisible = true;
		},
		refuseConfirm() {
			this.$refs.refuseFrom.validate(async valid => {
				if (valid) {
					let params = {
						cooperate_id: this.row.cooperate_id,
						refuse_content: this.refuseFrom.receive,
					};
					const { code } = await OrderRefuse(params);
					if (code == 0) {
						this.$message.success('操作成功');
						this.$emit('refreshList');
						this.dialogRefuseVisible = false;
					}
				}
			});
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
		},
	},
};
</script>
